import {useAllImportLogsQuery} from "../../api/importLog.slice.ts";
import {DataLoadingError} from "../../components/DataLoadingError.tsx";
import {DataGrid} from "../../components/DataGrid";
import {RIODateTime} from "../../lib/RIODateTime.ts";

const columns = [
    {key: "filename", label: "Filename"},
    {key: "activityCount", label: "Activity Count",},
    {key: "shiftCount", label: "Shift Count",},
    {
        key: "timestamp",
        label: "Timestamp",
        synthetic: true,
        render: (row: any) => row.timestamp ? RIODateTime.FromISO(row.timestamp).toPredefinedFormat(RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE_TIME) : ""
    },
    {
        key: "message",
        label: "Message",
    },
    {
        key: "success",
        label: "Success",
        synthetic: true,
        render: (row: any) => {
            if (row.success === null) return "";
            return row.success ? "✔" : "✖";
        }
    },
]


export const ImportLogList = () => {
    const {data, isLoading, error} = useAllImportLogsQuery()


    return <div>
        <DataLoadingError isLoading={isLoading} error={error}>
            <DataGrid data={data || []}
                      columns={columns}
            />
        </DataLoadingError>
    </div>
}